'use strict'

import _filter from 'lodash/filter'
import _find from 'lodash/find'

// workaround to achieve class injectors
let inj

// TODO companyId mit berückstichtigen, sobald vorhanden
export class UserFactory {
  constructor(data) {
    Object.assign(this, inj, data)
  }

  isOwner(customer) {
    const customerId = customer.no || customer
    return _find(this.customers, (c) => c.customer.no === customerId && _find(c.permissions, { isOwner: true }))
  }

  isAdmin(customer) {
    const customerId = customer.no || customer
    return _find(this.customers, (c) => c.customer.no === customerId && _find(c.permissions, { isAdmin: true }))
  }

  mayAccessDocuments(customer) {
    const customerId = customer.no || customer
    return _find(
      this.customers,
      (c) => c.customer.no === customerId && _find(c.permissions, { isAdmin: true, documents: true }),
    )
  }

  mayAccessReports(customer) {
    const customerId = customer.no || customer
    return _find(
      this.customers,
      (c) => c.customer.no === customerId && _find(c.permissions, { isAdmin: true, reports: true }),
    )
  }

  getAllPermissions(customer) {
    const customerId = customer.no || customer
    return _find(this.customers, (c) => c.customer.no === customerId).permissions
  }

  getAllTasksitePermissions(customer) {
    const customerId = customer.no || customer
    const permissions = _find(this.customers, (c) => c.customer.no === customerId).permissions
    return _filter(permissions, (p) => p.tasksiteId)
  }

  isTasksitePermitted(customer, tasksite) {
    const customerId = customer.no || customer
    const tasksiteId = tasksite.code || tasksite
    return this.hasPermission(customerId, tasksiteId)
  }

  hasPermission(customerId, tasksiteId) {
    return (
      this.isOwner(customerId) ||
      this.isAdmin(customerId) ||
      _find(this.customers, (c) => c.customer.no === customerId && _find(c.permissions, { tasksiteId }))
    )
  }

  static factory($q, $http) {
    'ngInject'
    inj = { $q, $http }
    return UserFactory
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/user.factory.js